module.exports = __webpack_public_path__ + "static/media/rasa-min.2a01792b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/rasa-min.png
// module id = 246
// module chunks = 0